import { Component, Input } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
	selector: 'app-dynamic-verified-text',
	templateUrl: './dynamic-verified-text.component.html',
	styleUrls: ['./dynamic-verified-text.component.scss']
})
export class DynamicVerifiedTextComponent {
	@Input() field: any;
	formName: FormGroup;

	constructor(private formgroupDirective: FormGroupDirective) {
		this.formName = this.formgroupDirective.control;
	}
}
